import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import YesodLogo from '../components/YesodLogo';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';

const ResetPasswordRequest = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { requestPasswordReset } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      console.log(`Requesting password reset for email: ${email}`);
      const response = await requestPasswordReset(email);
      console.log('Password reset request response:', response);
      setSuccess(true);
    } catch (err) {
      console.error('Password reset request failed:', err);
      // More detailed error reporting
      if (err.response) {
        console.error('Error response:', err.response.data);
        setError(err.response.data.message || 'Failed to process password reset request');
      } else if (err.request) {
        console.error('No response received from server');
        setError('Server not responding. Please try again later.');
      } else {
        console.error('Error message:', err.message);
        setError(err.message || 'An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <YesodLogo />
      
      <div className="auth-header">
        <h1 className="auth-title">Reset Password</h1>
        <p className="auth-subtitle">
          Enter your email and we'll send you a link to reset your password
        </p>
      </div>

      <div className="auth-form">
        {error && <div className="form-error">{error}</div>}
        {success && (
          <div className="form-success">
            Password reset link sent! Check your email.
          </div>
        )}
        
        {!success ? (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                className="form-input"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            
            <button 
              type="submit" 
              className="auth-button"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div className="reset-success-actions">
            <button 
              onClick={() => setSuccess(false)}
              className="auth-button secondary-button"
            >
              Try a different email
            </button>
          </div>
        )}

        <div className="auth-footer">
          <Link to="/" className="auth-link">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordRequest;